<template>
    <f7-page>
        <f7-navbar>
            <f7-nav-left back-link="Atrás" sliding></f7-nav-left>
            <f7-nav-title>Ver {{episodio.Ficha.titulo}} {{episodio.Episodio}}</f7-nav-title>
        </f7-navbar>
        <f7-block>

            <div v-if="isPlaying">
                <video autoplay="true" :src="episodio.Directo" style="width:100%;" loop :poster="episodio.Fotograma"
                       type="video/mp4" controls></video>
            </div>
            <div v-else>
                <a @click="marcarVisto()" style="width:100%;height:auto;display:block;background-size:cover;"
                   :style="'background-image: url(' + episodio.Fotograma + ')'">
                    <f7-icon size="50"
                             style="background-color:rgba(0,0,0,0.3);margin:0 auto;padding-top:50px;padding-bottom:50px;width:100%;text-align: center"
                             icon="material-icons">play_circle_outline
                    </f7-icon>
                </a>
            </div>

        </f7-block>
    </f7-page>
</template>

<script>
    export default {
        props: ['idAnime', "idEpisodio"],
        data() {
            return {
                isPlaying: false,
                episodio: {
                    Fotograma: '',
                    Episodio: '',
                    Directo: '',
                    Ficha: {
                        titulo: '',
                    }
                },
                allowInfinite: true,
                showPreloader: true,
            }
        },
        methods: {
            cargar() {
                let self = this;
                self.$f7.preloader.show();
                this.$f7.request.json('https://www.jkanimeapp.com/ios/api.php?action=getEnlaces&idEpisodio=' + this.idEpisodio, function (data) {
                    self.episodio = data.response;
                    self.$f7.preloader.hide();
                });
            },
            marcarVisto() {
                let self = this;
                self.$f7.preloader.show();
                this.$f7.request.json('https://www.jkanimeapp.com/ios/api.php?action=verEpisodio&idEpisodio=' + this.idEpisodio, function (data) {
                    self.isPlaying = true;
                    self.$f7.preloader.hide();
                });
            }
        },
        mounted() {
            let self = this;
            this.$f7ready((f7) => {
                self.cargar();
            })
        },
    }
</script>
